import React from "react";
import { Section, SectionHeading } from "../Section";
import { painPoints } from "../../data/landing";
export function PainSection() {
  return <Section tone="white" cta="I want a structured case-review system" data-id="element-212" data-mp="2wixb2poffg6a">
      <SectionHeading title="If you've ever looked at a new breast augmentation case and thought…" data-id="element-213" data-mp="2rhzw0lypr290" />

      <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-214" data-mp="2miwrd2mnay1k">
        {painPoints.map(p => <article key={p.quote} className="flex flex-col rounded-2xl border border-line bg-cream p-6" data-id="element-215" data-mp="2hlwthezy91lj">
            <div className="h-7 w-7 text-rose" aria-hidden="true" data-id="element-216" data-mp="2ct3mekh0dh6a" />
            <h3 className="mt-3 font-serif text-xl font-bold leading-snug text-ink" data-id="element-217" data-mp="28sbdjsc1teaj">“{p.quote}”</h3>
            <p className="mt-2 text-[16px] leading-relaxed text-inkSoft" data-id="element-218" data-mp="23tqazm9bqiix">{p.detail}</p>
          </article>)}
      </div>

      <div className="mx-auto mt-10 max-w-2xl rounded-2xl bg-roseSoft p-6 text-center md:p-8" data-id="element-219" data-mp="1yun8o9kqaqen">
        <p className="text-[17px] leading-relaxed text-ink md:text-lg" data-id="element-220" data-mp="1tv0vu18tbc6d">
          And I don't think the answer is necessarily another 20-hour course.
        </p>
        <p className="mt-3 font-serif text-xl font-bold text-ink md:text-2xl" data-id="element-221" data-mp="19qxz0vaebnja">
          Sometimes what you need is a better process for working through the information you already have.
        </p>
      </div>
    </Section>;
}